/**
 * Central network-status flag. The socket layer (on an involuntary close/reconnect) and the HTTP
 * layer (on a fetch/network failure) call notifyNetworkError(); a successful request or socket open
 * calls notifyNetworkRecovered(). A sticky banner (see app.tsx) subscribes and stays visible the
 * whole time the error is active — until the connection actually recovers.
 */
let networkErrorActive = false;
const listeners = new Set<(active: boolean) => void>();

const emit = () => listeners.forEach((l) => l(networkErrorActive));

export const notifyNetworkError = (): void => {
  if (networkErrorActive) return;
  networkErrorActive = true;
  emit();
};

export const notifyNetworkRecovered = (): void => {
  if (!networkErrorActive) return;
  networkErrorActive = false;
  emit();
};

export const isNetworkErrorActive = (): boolean => networkErrorActive;

/** Subscribe to network-error changes; returns an unsubscribe fn. */
export const subscribeNetworkStatus = (
  listener: (active: boolean) => void
): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
